import React, { FC, useContext } from 'react';

import { LinkButton } from '@eika/button';
import { Modal } from '@eika/modal';

import { AppContext } from '../../containers/appContextContainer';
import { useTranslation } from '../../translations';

interface Props {
    showModal: boolean;
    setShowModal: (showModal: boolean) => void;
}

const ETakstInfoModal: FC<Props> = ({ showModal, setShowModal }) => {
    const { etakst, button } = useTranslation();
    const { appNameSpace } = useContext(AppContext);

    return (
        <Modal
            id="eTakstInfoModal"
            title={etakst.infoModalTitle}
            appNamespace={appNameSpace}
            setOpen={() => setShowModal(true)}
            open={showModal}
            onClose={() => setShowModal(false)}
        >
            <div className="row row-gap-large margin-top-larger">
                <div className="info-modal">
                    <span>{etakst.infoModalParagraf1}</span>
                </div>
                <div className="info-modal">
                    <span>{etakst.infoModalParagraf2}</span>
                </div>
                <div className="column justify-content-center">
                    <LinkButton
                        data-track-id="kreditt-boliglaan-etakst-info-modal"
                        data-track-linkname="lukk"
                        onClick={() => setShowModal(false)}
                    >
                        {button.lukk}
                    </LinkButton>
                </div>
            </div>
        </Modal>
    );
};

export default ETakstInfoModal;
